import { reflect } from '@effector/reflect'

import { facebookLogin, showAcceptTermsDialogFx } from './model'
import { FacebookButton as View } from './view'

export const FacebookButton = reflect({
    view: View,
    bind: {
        onClick: facebookLogin,
        onTermsNotAccepted: showAcceptTermsDialogFx,
    },
})
